import React, { useRef, useState, useEffect } from "react";
import CompanyHeader from "../../components/CompanyHeader";
import CompanySideMenu from "../../components/CompanySideMenu";
import { useParams } from 'react-router-dom';
import Dropdown from "../../components/Dropdown";
import { CONTENT_TYPES, NEWS_STATUS_OPTIONS, NEWS_STATUS_OPTION_TYPE, TAG_LOGIC_TYPE } from '../../constants/index'
import useCustomHook from "../../reducers/ContentCreateHook"
import { useSnackbar } from "notistack";
import CustomToast from "../../components/CustomToast";
import { getNews, getOptionsMaster, setErrorMainInageState } from "../../reducers/companyContent"
import { getTalentTagOptions } from "reducers/companyTalent";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import {LoadingSpinner} from "../../components/Icons";
import { PERMISSIONS } from '../../constants/index';
import TextInput from "../../components/TextInput";
import CustomTextarea from "../../components/CustomTextarea";
import ReturnButton from "../../components/ReturnButton";
import CustomButton from "../../components/CustomButton";
import NotFoundPage from "../../pages/NotFoundPage";
import Copyright from "../../components/Copyright";
import PresetImagesDialog from "./components/PresetImagesDialog";
import CustomSwitch from "../../components/CustomSwitch";
import CustomDatePicker from "../../components/CustomDatePicker";
import ConfirmPopup from "../../components/ConfirmPopup";
import CheckboxButton from "../../components/CheckboxButton";
import CustomMarkdownEditor from "../../components/CustomMarkdownEditor";
import TimeInput from "../../components/TimeInput";
import i18n from 'i18next';
import { TypeOptions } from "../companyJob/components/TypeOptions";
import UnsaveConfirmPopup from "../action/components/UnsaveConfirmPopup";
import { setIsFormDirty } from "reducers/app";
import { setIsOpenSearchTagsPanel } from "reducers/talentTag";
import { getTimeErrorMessage } from "../../utils/util";

const ContentCreate = () => {
  const {
    handleChangeFile, image, isOver, type, publishStatus, reservedHour, reservedMinute, news, errorState, formSubmitted,errorMsg,
    successMsg, loadingNews, isPublishReserved, notifyTalent, talentType, markDirty, handleDragLeave, handleDrop, handleDragOver,
    handleTypeChange, handleChange, handleFormSubmit, navigate, handleResetImage, handleSetNews, handleFormEdit, handleSetNewsWithEdit,
    validateFile, imageUrlToBlobFile, handlePublishStatusChange, handleChangePublishReserved, handleReservedHourChange,
    handleReservedMinuteChange, handleNotifyTalentChange, setErrorMsg, setSuccessMsg, handleDeleteNews, publicScheduleDate,
    handlePublicScheduleDateChange, handleChangeContent, publicTimeErrorMsg, hourMinuteRangeInvalidMsg, handleChangeTalentType, tagLogicTypes,
    handleSetTagLogicTypes, handleNavigateBack, handleCloseLeaveConfirm, handleGoToTagList, isLeavePage, urlLeave,
    handleCloseLeavePageConfirm, 
  } = useCustomHook()
  const fileRef = useRef<HTMLInputElement>(null);
  const [mode, setMode] = useState("edit"); // 'edit' | 'preview'
  const [presetImageOpen, setPresetImageOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [newsStatus, setNewsStatus] = useState([]);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const currentUser = useSelector((state: any) => state.currentUser);
  const { staffPermission } = currentUser;
  const { items, loading, success, error, actionName, actionStatus, optionsMaster, errorMainInageState,
  } = useSelector((state: any) => state.companyContent);
  const {talentTagOptions} = useSelector((state: any) => state.companyTalent);
  const {isFormDirty, showLeaveConfirm, isNavigatingAway} = useSelector((state: any) => state.app);
  const { id } = useParams<{ id: string }>();
  const [showToast, setShowToast] = useState(true);
  const [checkingAccess, setCheckingAccess] = useState(true);
  const [searchTagQuery, setSearchTagQuery] = useState("");
  const [errorMainImage, setErrorMainImage] = useState(false);

  useEffect(() => {
    return () => dispatch(setIsFormDirty(false));
  }, [])

  useEffect(() => {
    dispatch(getTalentTagOptions({searchQuery: searchTagQuery}));
  }, [searchTagQuery]);

  useEffect(() => {
    if (id && items && Object.keys(items).length > 0) {
      handleSetNewsWithEdit({ ...items });
    }
  }, [items, id, tagLogicTypes]);  

  useEffect(() => {
    if (!id) {
      if (staffPermission && staffPermission.hasOwnProperty(PERMISSIONS.NEWS_NEW)) {
        setCheckingAccess(false);
      }
    } else {
      if (
        staffPermission &&
        staffPermission.hasOwnProperty(PERMISSIONS.NEWS_EDIT) &&
        (news?.id || error)
      ) {
        setCheckingAccess(false);
      }
    }
  }, [id, staffPermission, news?.id, error]);

  useEffect(() => {
    if (id) {
      const data = {
        id: Number(id),
      }
      dispatch(getNews(data));
    }
    dispatch(getOptionsMaster({option: NEWS_STATUS_OPTION_TYPE}));
  }, []);

  useEffect(() => {
    if (optionsMaster && Object.keys(optionsMaster).length > 0) {
      const statusOptions = optionsMaster
        .filter((option: any) => option.name === NEWS_STATUS_OPTION_TYPE)
        .flatMap((option: any) =>
          option.option_list.map((subOption: any) => ({
            name: subOption.label,
            id: subOption.id,
            value: subOption.value,
          }))
        );

      const tagLogicTypes = optionsMaster
        .filter((option: any) => option.name === TAG_LOGIC_TYPE)
        .flatMap((option: any) => 
          option.option_list.map((subOption: any) => ({
            id: subOption.id,
            name: subOption.label,
          }))
        );

      handleSetTagLogicTypes(tagLogicTypes)
      setNewsStatus(statusOptions);
      if (!id && statusOptions) {
        handleSetNews({
          public_schedule_date: null,
          is_public_scheduled: false,
          do_send_notification_email: true,
          status: statusOptions.find(status => status.value === NEWS_STATUS_OPTIONS.PUBLIC)?.id,
          news_status_display: statusOptions.find(status => status.value === NEWS_STATUS_OPTIONS.PUBLIC),
          tags_condition: tagLogicTypes[0],
          talent_types: talentType
        })
      }
    }
  }, [id, optionsMaster]);

  useEffect(() => {
    const requiredKeys = ['image', 'title', 'contents', 'type'];
    let msg = (<>必須項目が入力されていません。<br/>項目をご確認ください。</>);
    if(errorState && requiredKeys.some(key => !!errorState[key]?.trim()) && showToast){      
      showCustomToast({message: msg, variant: "error"});
      setShowToast(false);
      return;
    }
 
    const scheduleKeys = ['public_schedule_date', 'public_schedule_hour', 'public_schedule_minute'];
    if(errorState && scheduleKeys.some(key => !!errorState[key]?.trim()) && showToast) {
      if(scheduleKeys.every(key => errorState[key] === publicTimeErrorMsg)){
        showCustomToast({title: "入力内容を修正してください", message: publicTimeErrorMsg, variant: "error", type: "display_title"});
        setShowToast(false);
        return;
      } else if (scheduleKeys.some(key => errorState[key] === hourMinuteRangeInvalidMsg)) {
        showCustomToast({title: "入力内容を修正してください", message: hourMinuteRangeInvalidMsg, variant: "error", type: "display_title"});
        setShowToast(false);
        return;
      }
 
      showCustomToast({message: msg, variant: "error"});
      setShowToast(false);
      return;      
    }
 
    const otherError = ['tags'];
    if(errorState && otherError.some(key => !!errorState[key]?.trim()) && showToast){   
      const firstErrorKey = otherError.find(key => !!errorState[key]?.trim())
      msg = errorState[firstErrorKey] ? errorState[firstErrorKey] : null; 
      if (msg) {
        showCustomToast({message: msg, variant: "error"});
      }
      setShowToast(false);
      return;
    }
  }, [errorState]);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const showCustomToast = ({title="メッセージ", message, variant="success", type="normal"}) => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast
          title={title}
          message={message}
          variant={variant}
          snackbarKey={key}
          closeSnackbar={closeSnackbar}
          type={type}
        />
      ),
    });
  }
  useEffect(() => {
    if(errorMsg) {
      showCustomToast({message: errorMsg, variant: "error"});
      setErrorMsg('');
    }
    else if(successMsg) {
      showCustomToast({message: successMsg});
      setSuccessMsg('');
    }
  }, [errorMsg, successMsg]);

  useEffect(() => {
    if(errorMainInageState){ 
      setErrorMainImage(true)
      showCustomToast({message: errorMainInageState, variant: "error"});
      return;
    } else {
      setErrorMainImage(false)
    }
  }, [errorMainInageState]);

  //Access to this page is denied
  if (checkingAccess) {
    return null;
  }
  if ((!id && !staffPermission[PERMISSIONS.NEWS_NEW]) ||
      (id && !staffPermission[PERMISSIONS.NEWS_EDIT]) ||
      (id && !news.id)) {
    return <NotFoundPage />;
  }

  const handlePresetImageSelect = async (imageUrl: string) => {
    markDirty();
    try {
      dispatch(setErrorMainInageState(''));
      const file = await imageUrlToBlobFile(imageUrl);
      validateFile(file); // Now it's treated like an uploaded file
      handleClosePresetDialog();
    } catch (err) {
      setErrorMsg(i18n.t('MSG_CONTENT_IMAGE_CONVERSION_FAILED'));
    }
  };

  const handleClosePresetDialog = () => {
    setPresetImageOpen(false);
  }

  const handleChangeTime = (name: string, value: string | number) => {
    markDirty();
    if (name == "public_schedule_hour") {
      handleReservedHourChange(value);
      return;
    }
    if (name == "public_schedule_minute") {
      handleReservedMinuteChange(value);
      return;
    }
  };

  const handleClickSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    setShowToast(true);
    if (id) {
      handleFormEdit(e, Number(id));
    } else {
      handleFormSubmit(e);
    }
  };

  const scheduleErrorMsg = getTimeErrorMessage(errorState.public_schedule_date, errorState.public_schedule_hour, errorState.public_schedule_minute, null, null)

  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
        <CompanySideMenu />
        <div className="flex-1">
          <div className="mb-6 flex items-center gap-4">
            <ReturnButton onClick={handleNavigateBack} />
            <span className="text-sm alu-text-base-1">/</span>
            <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
              ニュースの{!id ? "追加" : "編集"}
            </h3>
          </div>

          <div className="bg-white rounded-lg p-4">
            <form onSubmit={event => event.preventDefault()} className="w-full">
              <div className="mb-6">
                <label
                  htmlFor="thumbnail"
                  className="block mb-2 text-sm font-bold alu-text-base-2"
                >
                  画像の追加 <span className="alu-text-error">*</span>
                </label>
                <div className="flex gap-4 xl:gap-8">
                  <div className={`relative w-[75%] xl:w-[60%] ${errorState.image || image || errorMainImage ? "h-[21.25rem]" : "h-[18.75rem]"}`}>
                    <input
                      accept="image/png, image/jpeg"
                      onChange={handleChangeFile}
                      type="file"
                      className="hidden"
                      ref={fileRef}
                    />
                    <div className="w-full absolute top-0 left-0">
                      <div
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={() => {
                          if (!fileRef || !fileRef.current) {
                            return
                          }
                          return fileRef.current.click()
                        }}
                        className={`hover:cursor-pointer rounded-lg w-full h-[18.75rem] ${isOver ? "bg-[#009CF2]" : "bg-[#F7F7F7]"
                          } flex flex-col gap-4 items-center justify-center ${errorState.image || errorMainImage ? "border-2 border-[#F33D62]" : ""
                          }`}
                      >
                        {!image ? (
                          <>
                            <button>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_10995_14344)">
                                  <path
                                    d="M12.0003 21.3333H20.0003V13.3333H25.3337L16.0003 4L6.66699 13.3333H12.0003V21.3333ZM6.66699 24H25.3337V26.6667H6.66699V24Z"
                                    fill={`${isOver ? "#fff" : "#808080"}`}
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_10995_14344">
                                    <rect width="32" height="32" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </button>
                            <p
                              className={`text-sm leading-[1.3125rem] ${isOver ? "text-white" : "alu-text-base-1"
                                } text-center`}
                            >
                              画像をドラッグするか、
                              <br />
                              <span className="text-[#FF861A] underline decoration-solid">
                                こちら
                              </span>{" "}
                              をクリックして画像を選択してください。
                            </p>
                          </>
                        ) : (
                          <img
                            className="h-full w-full object-contain"
                            src={image}
                            alt="news"
                          />
                        )}
                      </div>
                      {errorState.image && <p className="alu-text-error text-sm mt-2">{errorState.image}</p>}
                      {image ? <CustomButton customStyle="mt-2" variant="text" onClick={handleResetImage}>画像を取り消す</CustomButton> : ""}
                    </div>
                  </div>
                  <div className="w-[25%] xl:w-[40%] px-4 xl:px-6">
                    <p className="text-xs alu-text-base-1">
                      <span className="text-[#FF47CE]"></span>
                      アップロードできる画像は、横:1980 ✕ 縦:720、ファイル容量は8MB以内です。またファイル形式は png と jpg をアップロードできます
                      <br/><br/>
                      画像のご用意がない場合、<span className="text-link underline underline-offset-2 hover:cursor-pointer" onClick={() => setPresetImageOpen(prev => !prev)}>プリセット画像</span> もご利用できます。
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-6 flex gap-4 xl:gap-8">
                <div className="flex gap-6 w-[75%] xl:w-[60%]">
                  <label className="block text-sm font-bold alu-text-base-2 mt-2">
                    ジャンル <span className="alu-text-error">*</span>
                  </label>
                  <div className="flex-1">
                    <Dropdown 
                      placeholder={"選択してください"} 
                      type={"default"} 
                      options={CONTENT_TYPES} 
                      value={type} 
                      onChange={handleTypeChange} 
                      error={errorState.type}
                    />
                    {errorState.type && <p className="alu-text-error text-sm mt-2">*{errorState.type}</p>}
                  </div>
                </div>
                <div className="w-[25%] xl:w-[40%]"></div>
              </div>

              <div className="mb-6 flex gap-4 xl:gap-8">
                <div className="flex flex-col w-[75%] xl:w-[60%]">
                  <label className="block mb-2 text-sm font-bold alu-text-base-2">
                    タイトル <span className="alu-text-error">*</span>
                  </label>
                  <TextInput
                    type="text"
                    id="title"
                    name="title"
                    placeholder="入力してください"
                    value={news?.title || ""}
                    onChange={(e:any) => handleChange(e, "title")}
                    error={errorState.title}
                    errorText={errorState.title}
                  />
                </div>
                <div className="w-[25%] xl:w-[40%]"></div>
              </div>
              
              <div className="flex items-start gap-4 xl:gap-8">
                <div className="flex items-start gap-4 xl:gap-8 w-[75%] xl:w-[60%]">
                  <label
                    className="mt-2 block shrink-0 text-sm font-bold alu-text-base-2 pointer-events-none"
                    htmlFor="allowance"
                  >
                    タレントの種別 <span className="alu-text-error">*</span>
                  </label>
                  <div className="flex-1 flex-wrap flex gap-2">
                    {talentType?.map((itemType, idx) => (
                      <div key={idx} className="">
                        <CheckboxButton
                          name={itemType.name}
                          label={itemType.label}
                          value={itemType.value}
                          tabindex={24}
                          onChange={() => handleChangeTalentType(idx)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div className='px-4 xl:px-6 w-[25%] xl:w-[40%] mt-2'>
                  <p className="text-xs alu-text-base-1">選択した種別のタレントにニュースを表示します。</p>
                </div>
              </div>
              <div className="mb-4">
                {(errorState.talentType && errorState.talentType) && (
                  <p className="alu-text-error text-sm">
                      {errorState.talentType ? `*${errorState.talentType}` : ""}
                    </p>
                  )}
              </div>
              <div className='mb-8 flex items-start gap-4 xl:gap-8'>
                <div className="flex items-start gap-4 xl:gap-8 w-[75%] xl:w-[60%]">
                  <label className="block shrink-0 text-sm mb-2 alu-text-base-2 font-bold mt-2">タレントタグ</label>
                  <div className="flex-1 flex items-start flex-wrap gap-3">
                    <div className='w-full xl:w-[calc(100%-96px-12px)] 2xl:w-[474px]'>
                      <Dropdown
                        clearable={true}
                        inputWidth="full"
                        options={talentTagOptions}
                        placeholder=""
                        value={news?.news_tags || ""}
                        onChange={(value) => handleChangeContent(value, "news_tags")}
                        multiple={true}
                        havingIcon={false}
                        searchInput={true}
                        searchQuery={searchTagQuery}
                        setSearchQuery={setSearchTagQuery}
                        customStyle='!max-h-full'
                        isMinHeight={true}
                        isValuesTruncated={false}
                        noOptionsFoundText={searchTagQuery ? '指定した条件のタグは見つかりませんでした' : 'タグが登録されていません'}
                        optionStyles='px-2 py-[0.125rem] rounded-sm bg-[#F7F7F7] text-center'
                        actionsButton={[{ name: 'タグ管理', variant: 'outline', handleClick: () => handleGoToTagList()}]}
                      />
                    </div>
                    <div className='w-[96px] shrink-0'>
                      <Dropdown
                        inputWidth="full"
                        options={tagLogicTypes}
                        placeholder=""
                        value={news?.tags_condition}
                        onChange={(value) => handleChangeContent(value, "tags_condition")}
                      />
                    </div>
                  </div>
                </div>
                <div className='w-[25%] xl:w-[40%] px-4 xl:px-6 mt-2'>
                  <p className="text-xs alu-text-base-1">選択したタレントタグのタレントにニュースを表示します。</p>
                </div>
              </div>
              <div className="mb-6 flex gap-4 xl:gap-8">
                <div className="flex flex-col w-[75%] xl:w-[60%]">
                  <label className="block mb-2 text-sm font-bold alu-text-base-2">
                    タグ
                  </label>
                  <TextInput
                    type="text"
                    id="tags"
                    name="tags"
                    placeholder="入力してください"
                    value={news?.tags || ""}
                    onChange={(e:any) => handleChange(e, "tags")}
                    error={errorState.tags}
                    errorText={errorState.tags}
                  />
                </div>
                <div className="w-[25%] xl:w-[40%]"></div>
              </div>

              <div className="mb-6 flex gap-4 xl:gap-8">
                <div className="flex flex-col w-[75%] xl:w-[60%]">
                  <label className="block mb-2 text-sm font-bold alu-text-base-2">
                    本文 <span className="alu-text-error">*</span>
                  </label>

                  <div className="relative">
                    <CustomMarkdownEditor
                      error={errorState.contents}
                      errorText={errorState.contents}
                      placeholder="入力してください"
                      value={news.contents}
                      onChangeText={(text) => handleChangeContent(text, "contents")}
                    />
                  </div>
                </div>

                <div className="w-[25%] xl:w-[40%]"></div>
              </div>

              <div className="mb-6 flex gap-4 xl:gap-8">
                <div className="flex items-center gap-6 w-[75%] xl:w-[60%]">
                  <label className="block text-sm font-bold alu-text-base-2">
                    公開ステータス
                  </label>
                  <div className="flex-1">
                    <Dropdown 
                      placeholder={"選択してください"} 
                      type={"default"} 
                      options={newsStatus}
                      value={publishStatus}
                      onChange={handlePublishStatusChange}
                      error={errorState.publishStatus}
                      errorText={errorState.publishStatus}
                    />
                  </div>
                </div>
                <div className="w-[25%] xl:w-[40%]"></div>
              </div>

              <div className="mb-6 flex gap-4 xl:gap-8">
                <div className="w-[75%] xl:w-[60%]">
                  <div className="flex items-center gap-4 mb-4">
                    <label className={`block text-sm font-bold ${publishStatus?.value === NEWS_STATUS_OPTIONS.PRIVATE || news.is_public ? "text-[#BBBBBB]" : "alu-text-base-2"}`}>
                      公開予約
                    </label>
                    <div className="flex-1">
                      <CustomSwitch checked={isPublishReserved}
                        onChange={(e: any) => handleChangePublishReserved(e.target.checked)}
                        disabled={publishStatus?.value === NEWS_STATUS_OPTIONS.PRIVATE || news.is_public}
                      />
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-[264px]">
                      <CustomDatePicker
                        disabled={!isPublishReserved || publishStatus?.value === NEWS_STATUS_OPTIONS.PRIVATE || news.is_public}
                        placeholderText="YYYY年M月D日"
                        minDate={new Date()}
                        maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
                        value={publicScheduleDate}
                        onChange={(newValue: any) => handlePublicScheduleDateChange(newValue)}
                        error={errorState.public_schedule_date}
                        placeholderText={""}
                      />
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-[4.25rem] xl:w-[6.25rem]">
                        <TimeInput
                          size="md"
                          type="text"
                          maxLength={2}
                          id="public_schedule_hour"
                          name="public_schedule_hour"
                          value={reservedHour}
                          onChange={handleChangeTime}
                          placeholder="00"
                          error={errorState.public_schedule_hour}
                          errorText=""
                          disabled={!isPublishReserved || publishStatus?.value === NEWS_STATUS_OPTIONS.PRIVATE || news.is_public}
                          customClassName="disabled:bg-[#F7F7F7] disabled:text-[#BBBBBB]"
                        />
                      </div>
                      <span>:</span>
                      <div className="w-[4.25rem] xl:w-[6.25rem]">
                        <TimeInput
                          size="md"
                          type="text"
                          maxLength={2}
                          id="public_schedule_minute"
                          name="public_schedule_minute"
                          value={reservedMinute}
                          onChange={handleChangeTime}
                          placeholder="00"
                          error={errorState.public_schedule_minute}
                          errorText=""
                          disabled={!isPublishReserved || publishStatus?.value === NEWS_STATUS_OPTIONS.PRIVATE || news.is_public}
                          customClassName="disabled:bg-[#F7F7F7] disabled:text-[#BBBBBB]"
                        />
                      </div>
                    </div>
                  </div>
                  {scheduleErrorMsg && (
                    <p className="alu-text-error text-sm mt-2">
                      *{scheduleErrorMsg}
                    </p>
                  )}
                </div>
                <div className="w-[25%] xl:w-[40%] px-4 xl:px-6">
                  <p className="text-xs alu-text-base-1">
                    現在時刻の1時間後から予約できます。<br/>
                    公開ステータスが「非公開」の場合、公開予約は使用できません。
                  </p>
                </div>
              </div>

              <div className="mb-6 flex gap-4 xl:gap-8">
                <div className="flex items-center gap-6 w-[75%] xl:w-[60%]">
                  <CheckboxButton
                    id="notifyTalent"
                    name="notifyTalent"
                    value={notifyTalent}
                    label={"タレントにニュースの公開をメールで通知する"}
                    onChange={(e:any) => {handleNotifyTalentChange(!notifyTalent); markDirty();}}
                    disabled={news.publication_count}
                  />
                </div>
                <div className="w-[25%] xl:w-[40%]"></div>
              </div>

              <div className="flex gap-4 xl:gap-8">
                <div className="flex flex-col w-[75%] xl:w-[60%] pb-6 border-b border-[#E0E0E0]">
                  <div className="pt-4 flex items-center justify-between">
                    <CustomButton
                      onClick={() => navigate(-1)}
                      variant="text"
                    >
                      キャンセル
                    </CustomButton>
                    <div className="flex items-center gap-12">
                      <CustomButton
                        onClick={handleClickSubmit}
                        variant="outline"
                        size="md"
                        disabled={loadingNews || formSubmitted || (news.is_public && publishStatus?.value != NEWS_STATUS_OPTIONS.PRIVATE) || publishStatus?.value != NEWS_STATUS_OPTIONS.PRIVATE}
                      >
                        <p>{loadingNews ? "保存中..." : "保存"}</p>
                        {loadingNews && (
                          <span><LoadingSpinner /></span>
                        )}
                      </CustomButton>
                      <CustomButton
                        type="submit"
                        size="md"
                        customStyle="!min-w-[10rem]"
                        onClick={handleClickSubmit}
                        disabled={loadingNews || formSubmitted || publishStatus?.value === NEWS_STATUS_OPTIONS.PRIVATE}
                      >
                        <p>{loadingNews ? "保存中..." : !isPublishReserved ? "公開" : "公開予約"}</p>
                        {loadingNews && (
                          <span><LoadingSpinner /></span>
                        )}
                      </CustomButton>
                    </div>
                    
                  </div>
                </div>
                <div className="w-[25%] xl:w-[40%]"></div>
              </div>
              <CustomButton
                onClick={() => setIsConfirmOpen(true)}
                variant="text"
                customStyle="mt-4 mb-1"
                disabled={!id}
              >
                この記事を削除
              </CustomButton>
            </form>
          </div>
        </div>
      </div>
      <Copyright view="company" />
      <PresetImagesDialog open={presetImageOpen} onClose={handleClosePresetDialog} onConfirm={handlePresetImageSelect} />
      {isConfirmOpen && (
        <ConfirmPopup
          type="delete"
          open={isConfirmOpen}
          onClose={() => setIsConfirmOpen(false)}
          confirmContent={`${news.title} を削除します。よろしいですか？`}
          onConfirm={(e) => {(id ? handleDeleteNews(e, Number(id)) : handleDeleteNews(e));setIsConfirmOpen(false);}}
          cancelText="キャンセル"
        />
      )}
      {showLeaveConfirm && !isNavigatingAway && <UnsaveConfirmPopup
        open={showLeaveConfirm}
        onClose={handleCloseLeaveConfirm}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={() => {handleCloseLeaveConfirm();dispatch(setIsFormDirty(false));navigate(-1);}}
      />}
      {isLeavePage && <UnsaveConfirmPopup
        open={isLeavePage}
        onClose={handleCloseLeavePageConfirm}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={() => {handleCloseLeavePageConfirm();dispatch(setIsFormDirty(false));navigate(urlLeave);}}
      />}
    </>
  );
}

export default ContentCreate